import React from "react";
import "../Styles/ClientInviteCard.css";

const ClientInviteCard = ({ userData }) => {
   const handleCopy = () => {
    navigator.clipboard.writeText(userData?.ClientCode);
  };
  return (
    <div className="card-wrapper">
      <div className="card-header">
        <span className="card-title">
          Share Profile code to client to help them to join
        </span>
        <button className="continue-button">
          Let Client Fill & Continue →
        </button>
      </div>

      <div className="card-body">
        <p className="client-name">
         Profile Name : {userData?.User?.FirstName} {userData?.User?.LastName}{" "}
        </p>
        <p className="client-code">
          Client code: <strong> {userData?.ClientCode} </strong>
           <img
          src={require("../assests/images/copy-icon.png")}
          alt="Copy"
          className="copy-icon"
          onClick={handleCopy}
        />
        </p>
       

        {/* <a
          href="https://wedluk.com/join/sona-vikram07"
          className="client-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://wedluk.com/join/sona-vikram07
        </a> */}
      </div>
    </div>
  );
};

export default ClientInviteCard;
